import { useContext } from 'react';
import { DriveContext } from '../context/DriveContext';

const useDrive = () => {
  const context = useContext(DriveContext);

  if (!context) {
    throw new Error('useDrive must be used inside DriveProvider');
  }

  return context;
};

export default useDrive;
